import React from 'react';

const SvgCourseTime = props => (
  <svg data-name="Layer 1" viewBox="0 0 28.29 28.29" {...props}>
    <path d="M14.15 0A14.15 14.15 0 1028.3 14.15 14.16 14.16 0 0014.15 0zm0 26.79A12.65 12.65 0 1126.8 14.14 12.66 12.66 0 0114.15 26.8z" />
    <path d="M14.9 13.4V3.32h-1.5V14.9h11.58v-1.5H14.9z" />
  </svg>
);

export default SvgCourseTime;
